module.exports = __webpack_public_path__ + "static/img/checkIn.4e483c01.png";